import styled from 'styled-components';

import { CartItemEditContainer as CartItemEditContainerDefault } from './cart-item-edit-container.default';

const CartItemEditContainer = styled(CartItemEditContainerDefault)`
  border-top-color: ${Styles.color.background};
`;

export default CartItemEditContainer;
